import {message} from '@sail/intl';

export const customerLogoTitle = message<{companyName: string}>({
  id: 'mkt-ssr.customer_logo.title',
  defaultMessage: '{companyName} logo',
  description: 'Accessible title for customer logo SVGs',
});
